import * as actionTypes from './action-types';
import { API_REQUEST } from '../../../../store/sagas/api';
import { getCoursesCheckoutInformation } from '../../../../backend-api';

export const loadCoursesCheckoutInformation = (courseId, { email = null, currency = null, promocode = null } = {}) => ({
  type: API_REQUEST,
  types: [
    actionTypes.LOAD_COURSES_CHECKOUT,
    actionTypes.LOAD_COURSES_CHECKOUT_SUCCESS,
    actionTypes.LOAD_COURSES_CHECKOUT_FAIL,
  ],
  call: () => getCoursesCheckoutInformation(courseId, { email, currency, promocode }),
});

export const updateCoursesCheckoutPrice = data => ({
  type: actionTypes.UPDATE_COURSES_CHECKOUT_PRICE,
  data,
});
